module.exports = __webpack_public_path__ + "media/images/recipes/schnitzel_gepaneerd-ce7e85149b20aebaec9067fde8522f31.pdf";